<template>

    <div>
        <form action="/passport/redeem" method="post" :disabled="!canRedeemAward">
        <csrf></csrf>
        <input type="hidden" name="award_id" :value="this.form.award">
        <div class="general-title">
            <div class="title">Redeem <person-name :model="child" :plural="true"></person-name> Stamps</div>
        </div>
        <div class="input-container">
            <div class="input-title"><person-name :model="child" :plural="true"></person-name> Stamps</div>
            <div class="input-box static-text"><span class="status-bubble good-bg white-text status-bubble-100">{{ balance }}</span></div>
        </div>
        <div class="input-container">
            <div class="input-title">Choose Award</div>
            <div class="input-box">
                <selectize v-model="form.award" placeholder="Choose Award">
                    <option v-for="award in awards" :key="`award-${ award.id }`" :value="award.id">{{ award.name }} ({{ award.stamps_required }} {{ award.stamps_required !== 1 ? 'Stamps' : 'Stamp' }})</option>
                </selectize>
            </div>
        </div>
        <div class="input-container">
            <div class="input-title">Balance After Purchase</div>
            <div class="input-box static-text"><span class="status-bubble white-text status-bubble-100" :class="{ 'neutral-bg': canRedeemAward, 'bad-bg': !canRedeemAward }">{{ balanceAfter }}</span></div>
        </div>
        <button v-if="canRedeemAward" type="submit" class="submit-standard good-bg">Redeem <person-name :model="child" :plural="true"></person-name> Stamps<span class="fa fa-stamp"></span></button>
        <button v-else type="submit" class="submit-standard grey-bg" disabled>Choose Award To Redeem<span class="fa fa-stamp"></span></button>
        </form>
    </div>

</template>

<script>

import { mapGetters } from 'vuex';
import _ from 'underscore';

export default {

    props: [ 'awards', 'balance' ],

    data() {
        return {
            form: { award: null },
        };
    },

    computed: {

        ...mapGetters([ 'child' ]),

        award() {
            return _.findWhere(this.awards, { id: parseInt(this.form.award) }) || null;
        },

        canRedeemAward() {
            return (this.award && this.award.stamps_required <= this.balance)
        },

        balanceAfter() {
            if (this.award) {
                if (this.canRedeemAward) {
                    return this.balance - this.award.stamps_required;
                } else {
                    return 'Not Enough Stamps';
                }
            }

            return this.balance;
        }

    }

};

</script>



// WEBPACK FOOTER //
// resources/js/components/passport/RedeemAward.vue